export const POGRESS_STATUS_COLOR_MAP = {
  normal: '#52c41a',
  exception: '#ff4d4f',
};
